/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccommodationListings_Listing_jsonld = {
    readonly '@id'?: string;
    readonly '@type'?: string;
    listingType?: AccommodationListings_Listing_jsonld.listingType;
    listingId?: string;
    listingName?: string;
};
export namespace AccommodationListings_Listing_jsonld {
    export enum listingType {
        CITY = 'city',
        REGION = 'region',
    }
}
